<script>
const anchorRegExp = /(?:\+?7|8)[0-9)( -]{10,16}/g;

const makeAnchorHtml = (formattedPhone) => {
  let digits = formattedPhone.replaceAll(/[^0-9]/g, '');
  if (digits.length !== 11) {
    return formattedPhone;
  }
  digits = digits.startsWith('7') ? `+${digits}` : digits;
  return `<a href="tel:${digits}">${formattedPhone}</a>`;
};

/**
 * @description Замена текстовых номеров телефонов на ссылки.
 * @type {Vue}
 */
export default {
  functional: true,
  name: 'PhoneNumbersToLinks',
  props: {
    /**
     * @description Текст для замены.
     */
    text: {
      required: true,
      type: String,
    },
  },
  render(createElement, context) {
    const innerHTML = context.props.text.replaceAll(anchorRegExp, makeAnchorHtml);
    return createElement('p', { domProps: { innerHTML } });
  },
};
</script>
